// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"13921":"fad47121e642b632f084","63598":"5097533d921f1eea007d"}[chunkId] + ".css";
};